/* src/services/settingsService.js */
import api from './api'

export default {

  async getSettings() {

    return await api.get('booking/settings/')
  },

  async saveSettings(settingsData) {

    return await api.post('booking/settings/save/', settingsData)
  },

  async testStripeConnection() {

    return await api.get('booking/stripe-test/')
  }
}
